import { render, staticRenderFns } from "./reply-item.vue?vue&type=template&id=56862f98&scoped=true&"
import script from "./reply-item.vue?vue&type=script&lang=js&"
export * from "./reply-item.vue?vue&type=script&lang=js&"
import style0 from "./reply-item.vue?vue&type=style&index=0&id=56862f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56862f98",
  null
  
)

export default component.exports